import { useState } from 'react';
import { PopoverShell } from '@/components/PopoverShell';
import AdTypeBadge from '@/components/AdTypeBadge';
import { ADV_TYPE_LABELS, ADV_TYPE_DESCRIPTIONS, ADV_TYPE_GUIDE_GROUPS } from '@/lib/constants/advTypes';
import { useI18nText } from '@/lib/utils/i18nText';

/**
 * Link next to "Add rate" (Channel Rates section) explaining what each content
 * type actually is — the type dropdown itself only has room for a short label
 * (e.g. "YT Stream Highlight"), which isn't always self-explanatory to a
 * marketer setting channel prices for the first time.
 */
export function AdTypeGuidePopover() {
  const { t } = useI18nText();
  const [open, setOpen] = useState(false);

  const triggerButton = (
    <button type="button" className="ggc-linked-text ad-type-guide-trigger">
      <i className="fa fa-question-circle mr-1" />
      {t('Ad Type Guide', '광고 유형 가이드')}
    </button>
  );

  return (
    <PopoverShell
      open={open}
      onOpenChange={setOpen}
      trigger={triggerButton}
      width={420}
      maxHeight="var(--radix-popper-available-height, 560px)"
      className="adv-type-guide-popover"
      resizable
    >
      {/* `.popover-shell` (PopoverShell's own Content box) has no `overflow: hidden` of
          its own, so a plain `max-height: inherit` on the body alone doesn't account for
          the header sitting above it — header + body could together exceed the shell's
          budget, and since nothing clips the shell itself, the excess spills out past its
          rounded card instead of scrolling. Wrapping both in a column flex box (capped at
          the same `max-height: inherit`) with the header `flex-shrink: 0` and the body
          `flex: 1; min-height: 0` gives the body only the *remaining* space to scroll in. */}
      <div className="adv-type-guide-content">
        <div className="email-stats-popover__header">
          <span className="email-stats-popover__title">{t('Ad Type Guide', '광고 유형 가이드')}</span>
          <button type="button" className="email-stats-popover__close" onClick={() => setOpen(false)}>
            <i className="fa fa-times" />
          </button>
        </div>
        <div className="adv-type-guide-body">
          {ADV_TYPE_GUIDE_GROUPS.map((group) => (
            <div key={group.label.en} className="adv-type-guide-group">
              <div className="adv-type-guide-group__title">{t(group.label.en, group.label.ko)}</div>
              {group.types.map((type) => (
                <div key={type} className="adv-type-guide-row">
                  <AdTypeBadge typeId={type} label={ADV_TYPE_LABELS[type]} className="shrink-0 ad-type-guide-badge" />
                  <span className="adv-type-guide-row__desc">
                    {t(ADV_TYPE_DESCRIPTIONS[type]?.en ?? '', ADV_TYPE_DESCRIPTIONS[type]?.ko ?? '')}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </PopoverShell>
  );
}
